import React, { useEffect ,useState} from "react";
import { Switch, Route } from "react-router-dom";
import { FacesheetContainer } from "./FacesheetContainer";
import { SupplementalContainer } from "./Supplemental/SupplementalContainer";
import { DispatchContainer } from "./DispatchContainer";
import { MarketplaceContainer } from "./MarketplaceContainer";
import { connect } from "react-redux";
import * as interviewActions from "../actions/interviewActions";
import * as householdActions from "../actions/householdAction";
import * as programActions from "../actions/programActions";
import { PaymentContainer } from "./PaymentCollectionContainer";
import { MarketplacePostApprovalContainer } from "./MarketplacePostApprovalContainer";
import * as personActions from "../actions/personActions";
import * as noteActions from "../actions/personNotesActions";
import * as documentActions from "../actions/documentActions";
import { isNullOrWhitespace } from "../services/stringService";
import { PostMarketplaceDataVerificationContainer } from "./Verification/DataVerificationContainers";
import { UmmcFaDocumentationContainer } from "./UmmcFADocumentation/UmmcFaDocumentationContainer";

const ProgramDependentComponent = ({
    match,
    config,
    encounterId,
    interviewPatientId,
    getHouseholds,
    getPrograms,
    getPerson,
    resetPrograms,
    getNotes,
    personId,
    customerId,
    customerCode,
    getDocuments,
    setIsError,
}) => {
    
    useEffect(() => {
        getPrograms(encounterId, customerId, config.showIneligiblePrograms)
        .then(() => {
            getHouseholds(encounterId);
        }).catch(data=>{
            setIsError()
        });
        return () => {
            resetPrograms();
        };
    }, [encounterId]);

    useEffect(() => {
        if (interviewPatientId != null) {
            getPerson(customerId, interviewPatientId);
        }
    }, [interviewPatientId]);

    useEffect(() => {
        if (personId == null) {
            return;
        }

        getNotes(customerCode, personId);
    }, [personId]);

    useEffect(() => {
        if (isNullOrWhitespace(interviewPatientId)) {
            return;
        }

        getDocuments(customerId, interviewPatientId);
    }, [interviewPatientId]);

    return (
        <Switch>
            <Route
                path={`${match.path}/facesheet`}
                render={props => <FacesheetContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/supplemental`}
                render={props => <SupplementalContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/verification`}
                render={props => <PostMarketplaceDataVerificationContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/approval`}
                render={props => <MarketplacePostApprovalContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/dispatch`}
                render={props => <DispatchContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/payment`}
                render={props => <PaymentContainer {...props} encounterId={encounterId} />}
            />
            <Route
                path={`${match.path}/marketplace`}
                exact
                render={props => (
                    <MarketplaceContainer
                        {...props}
                        showIneligiblePrograms={config.showIneligiblePrograms}
                        encounterId={encounterId}
                    />
                )}
            />
            <Route
                path={`${match.path}/UMMCFADocumentation`}
                exact
                render={props => (
                    <UmmcFaDocumentationContainer
                        {...props}
                        showIneligiblePrograms={config.showIneligiblePrograms}
                        encounterId={encounterId}
                    />
                )}
            />
        </Switch>
    );
};

export const ProgramDependentContainer = connect(
    (state, ownProps) => {
        const patientId = state.interview?.entry?.patient?.personId;
        let underlyingPerson = null;
        if (patientId) {
            underlyingPerson = state.person.data[patientId];
        }

        return {
            encounterId: ownProps?.match?.params?.encounterId,
            interviewPatientId: state.interview.entry.patient.personId,
            personId: underlyingPerson?.globalId,
            customerId: state.customer?.data?.customer?.GlobalId,
            customerCode: state.customer?.data?.customer?.code,

        };
    },
    dispatch => ({
        getHouseholds: encounterId => dispatch(householdActions.getHouseholds(encounterId)),
        getPrograms: (encounterId, customerId, includeIneligible = false, shouldReturnLTCProgram = true) =>
            dispatch(
                programActions.getEligiblePrograms(encounterId, customerId, includeIneligible, shouldReturnLTCProgram)
            ),
        getDocuments: (customerId, personId) => dispatch(documentActions.getDocuments(customerId, personId)),
        getPerson: (customerId, patientId) => dispatch(personActions.getPerson(customerId, patientId)),
        resetPrograms: () => dispatch(programActions.resetPrograms()),
        getNotes: (customerCode, personId) => dispatch(noteActions.getNotes(customerCode, personId)),
    })
)(ProgramDependentComponent);
